import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class WhiteHat extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M23.837,15.5s.178.049.162.2-.2-.022-.2-.022a43.263,43.263,0,0,0-11.355-2.893A46.7,46.7,0,0,0,.676,12.642c-1.013.1-.586-.064-.586-.064a47.323,47.323,0,0,1,12.141-.6A36.546,36.546,0,0,1,22.35,14.819c.4.174.963.433,1.487.682m-5.766-4.572c-.425-1.154-.9-2.292-1.815-2.617-.939-.335-3.1.5-5.058.806-1.349.212-2.47.276-2.865.307-.41.032-.773.285-.763.579s.617,1.409.537.977-.136-1.091.3-1.238c.167-.056,1.626-.2,2.98-.4,1.031-.147,2.061-.356,2.061-.356a6.435,6.435,0,0,1,2.262-.111,2.249,2.249,0,0,1,.88.454c.69.5,1.982,3.573,1.982,3.573a8.826,8.826,0,0,0-.5-1.978" />
      </svg>
    );
  }
}

export default WhiteHat;
